module.exports = __webpack_public_path__ + "img/service-04.89925d87.jpg";